import React from 'react';
import { Link } from 'react-router-dom';
import Footer from "../views/Footer";
import FadeIn from "../components/FadeIn";
import founderImg from "../assets/founder.jpeg";
const About = () => {

  const milestones = [
    { year: "July 2023", title: "Dubai Office Launch", description: "Started office in Dubai for MEP Design & BIM" },
    { year: "November 2023", title: "India Expansion", description: "Opened office in India (Chennai) with 6 employees" },
    { year: "July 2024", title: "MEP Execution", description: "Started MEP Execution services" },
    { year: "September 2024", title: "Indian Projects", description: "Started Design & Execution in Indian projects" },
    { year: "August 2025", title: "Team Growth", description: "Employee increase to 20+ employees" },
    { year: "September 2025", title: "Academy Launch", description: "Launched BIMBYTES Academy in Chennai (Avadi)" }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-12">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-textPrimary mb-6">
                <span className="text-gradient">About Us</span>
              </h1>
              <blockquote className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-textPrimary mb-6 italic">
                "The value of knowledge is realized only when it transform into action and innovation"
              </blockquote>
              <p className="text-lg text-textSecondary mb-8">- Y. Mohanakrishnan</p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Description & Team Photo Section */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <FadeIn delay={0.2} direction="left">
              <div>
                <h2 className="text-3xl font-bold text-textPrimary mb-6">Our <span className="text-primary">Origin Story</span></h2>
                <p className="text-lg text-textSecondary leading-relaxed mb-6">
                  Founded by <span className="font-bold text-primary">Y. Mohanakrishnan</span>, BIM Bytes Academy was born from a vision to revolutionize BIM education in India. With years of industry experience in Dubai and India, our founder recognized the gap between academic theory and the practical demands of the AEC industry.
                </p>
                <p className="text-lg text-textSecondary leading-relaxed">
                  BIM Bytes Academy helps engineers enhance their skills and transform into industry-ready professionals. We focus on practical learning and real-world applications, guiding engineers to grow with confidence and reach their career goals. We are dedicated to building engineers who are ready to excel in every challenge.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} direction="right">
              <div className="flex flex-col items-center gap-4">

                {/* Founder Image */}
                <div className="w-full max-w-[380px] rounded-2xl overflow-hidden shadow-2xl ring-1 ring-primary/10 bg-white p-3">
                  <img
                    src={founderImg}
                    alt="Founder - Y. Mohanakrishnan"
                    className="w-full rounded-2xl object-contain"
                  />
                </div>

                <p className="text-sm text-textSecondary italic text-center">
                  Founder - Y. Mohanakrishnan
                </p>

                {/* Team Image */}
                <div className="w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl ring-1 ring-primary/10">
                  <img
                    src={require('../assets/group.jpeg')}
                    alt="BIM Bytes Team"
                    className="w-full h-full object-cover"
                  />
                </div>

                <p className="text-sm text-textSecondary italic text-center">
                  The BIM Bytes Team
                </p>

              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                Our <span className="text-gradient">Mission & Vision</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                Driving innovation and excellence in BIM education
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <FadeIn delay={0.3} direction="left">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-crimson/10 to-black/20 rounded-3xl"></div>
                <div className="relative bg-white rounded-3xl p-8 shadow-lg ring-1 ring-crimson/20">
                  <div className="text-center mb-6">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-crimson rounded-2xl mb-4">
                      <span className="text-2xl text-white">🎯</span>
                    </div>
                    <h3 className="text-2xl font-bold text-textPrimary mb-3">Our Mission</h3>
                  </div>
                  <p className="text-lg text-textSecondary leading-relaxed text-center">
                    To bridge the gap between academic knowledge and industry requirements by providing
                    hands-on, project-based BIM training that prepares students for successful careers
                    in the AEC industry.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} direction="right">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-black/10 to-crimson/20 rounded-3xl"></div>
                <div className="relative bg-white rounded-3xl p-8 shadow-lg ring-1 ring-black/20">
                  <div className="text-center mb-6">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-crimson rounded-2xl mb-4">
                      <span className="text-2xl text-white">🚀</span>
                    </div>
                    <h3 className="text-2xl font-bold text-textPrimary mb-3">Our Vision</h3>
                  </div>
                  <p className="text-lg text-textSecondary leading-relaxed text-center">
                    To become the most trusted and preferred BIM training institute in India,
                    recognized for producing industry-ready professionals who drive innovation
                    and excellence in the construction sector.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Our Responsibilities */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                Our <span className="text-gradient">Responsibilities</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                We take our commitment to student success seriously
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Quality Education",
                description: "Delivering industry-standard BIM training with practical, hands-on experience",
                icon: "🎓"
              },
              {
                title: "Career Development",
                description: "Providing placement assistance and career guidance to all students",
                icon: "💼"
              },
              {
                title: "Industry Connection",
                description: "Building strong partnerships with companies for internship and job opportunities",
                icon: "🤝"
              },
              {
                title: "Continuous Support",
                description: "Offering ongoing mentorship and technical support even after course completion",
                icon: "🔄"
              },
              {
                title: "Skill Enhancement",
                description: "Regular curriculum updates to match evolving industry requirements",
                icon: "📈"
              },
              {
                title: "Student Success",
                description: "Ensuring every student achieves their career goals and professional growth",
                icon: "🎯"
              }
            ].map((responsibility, index) => (
              <FadeIn key={index} delay={0.2 + index * 0.1} direction="up">
                <div className="card p-6 text-center hover:shadow-glow transition-all duration-500 ease-smooth">
                  <div className="mb-4">
                    <div className="text-4xl mb-3">{responsibility.icon}</div>
                    <h3 className="text-lg font-bold text-textPrimary mb-2">{responsibility.title}</h3>
                    <p className="text-textSecondary text-sm">{responsibility.description}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>



      {/* Why BIM Bytes Academy */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                Why <span className="text-gradient">BIM Bytes Academy</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                What makes us the preferred choice for BIM professionals
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: "Expert Faculty", desc: "Learn from industry veterans with years of hands-on project experience." },
              { title: "Live Projects", desc: "Gain practical exposure by working on real-time international projects." },
              { title: "Global Standards", desc: "Master BIM workflows aligned with international industry standards." },
              { title: "Job Ready", desc: "Our curriculum is designed to make you productive from day one." }
            ].map((item, idx) => (
              <FadeIn key={idx} delay={0.1 * idx} direction="up">
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-border hover:shadow-md transition-all">
                  <h3 className="text-xl font-bold text-textPrimary mb-3">{item.title}</h3>
                  <p className="text-textSecondary">{item.desc}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Our Trainers Section */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                Meet Our <span className="text-gradient">Trainers</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                Learn from the experts who have shaped the industry
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
            {[
              { name: "Y. Mohanakrishnan", role: "Founder & Lead Trainer", img: founderImg },
              { name: "Senior BIM Expert", role: "MEP Specialist", img: require('../assets/Sonai Muthu.jpeg') },
              { name: "Janarthanan", role: "Mechanical Trainer", img: require('../assets/Janarthanan.png') },
              { name: "Mari Selvam", role: "Mechanical Trainer", img: require('../assets/MARI SELVAM.jpeg') },
              { name: "Deepak", role: "Electrical Trainer", img: require('../assets/DEEPAK.jpeg') }
            ].map((trainer, idx) => (
              <FadeIn key={idx} delay={0.1 * idx} direction="up">
                <div className="text-center group">
                  <div className="relative w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden ring-4 ring-primary/20 group-hover:ring-primary/40 transition-all">
                    <img src={trainer.img} alt={trainer.name} className="w-full h-full object-cover" />
                  </div>
                  <h3 className="text-xl font-bold text-textPrimary">{trainer.name}</h3>
                  <p className="text-primary font-medium">{trainer.role}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Company Journey */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                Our <span className="text-gradient">Journey</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                From humble beginnings to becoming India's leading BIM training institute
              </p>
            </div>
          </FadeIn>

          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-gradient-to-b from-primary to-secondary"></div>

            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <FadeIn key={index} delay={0.2 + index * 0.1} direction={index % 2 === 0 ? "left" : "right"}>
                  <div className={`relative flex items-center ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                    <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                      <div className="card p-6 hover:shadow-glow transition-all duration-500 ease-smooth">
                        <div className="text-2xl font-bold text-primary mb-2">{milestone.year}</div>
                        <h3 className="text-xl font-bold text-textPrimary mb-2">{milestone.title}</h3>
                        <p className="text-textSecondary">{milestone.description}</p>
                      </div>
                    </div>

                    {/* Timeline Dot */}
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-primary rounded-full border-4 border-white shadow-lg"></div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="bg-crimson py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FadeIn delay={0.2} direction="up" fullWidth>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
              Join the BimBytes Family
            </h2>
            <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto">
              Be part of our success story and start your journey towards a rewarding BIM career
            </p>
            <Link to="/courses" className="btn-white px-6 py-3 text-base inline-block">Explore Courses</Link>
          </FadeIn>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About;